// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { Image, View, Text, TouchableOpacity } from "react-native";
import { FontAwesome, MaterialCommunityIcons } from "@expo/vector-icons";
import HeaderStyle from "../styles/HeaderStyle";
import translations from "../config/translation.json";
import { LogoutRequest } from "../axios/axiosConfig";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { updateLanguage } from "../utils/utils";
import CountryFlag from 'react-native-country-flag';

const languages = [
  { code: "DE", name: "German", flag: "DE" },
  { code: "IT", name: "Italian", flag: "IT" },
];

const Header = ({ user, title, subtitle, icon, loginStatus }) => {
  const [language, setLanguage] = useState("DE");
  const [translatedTitle, setTranslatedTitle] = useState(title);
  const [translatedSubtitle, setTranslatedSubtitle] = useState(subtitle);

  useEffect(() => {
    const loadLanguagePreference = async () => {
      try {
        const storedLanguage = await AsyncStorage.getItem("preferredLanguage");
        if (storedLanguage) {
          setLanguage(storedLanguage);
        } else {
          await AsyncStorage.setItem("preferredLanguage", "DE");
        }
      } catch (error) {
        console.error("Error loading language preference:", error);
      }
    };
    loadLanguagePreference();
  }, []);

  useEffect(() => {
    const fetchTranslations = async () => {
      const translatedTitleText = await getTranslation(title);
      setTranslatedTitle(translatedTitleText);

      if (subtitle) {
        const translatedSubtitleText = await getTranslation(subtitle);
        setTranslatedSubtitle(translatedSubtitleText);
      }
    };

    fetchTranslations();
  }, [title, subtitle, language]);

  const handleLanguageChange = async (selectedLanguage) => {
    setLanguage(selectedLanguage);
    try {
      updateLanguage(selectedLanguage);
      await AsyncStorage.setItem("preferredLanguage", selectedLanguage);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  const handleLogout = async () => {
    loginStatus(false);
    try {
      await AsyncStorage.removeItem("userData");
      await LogoutRequest();
      loginStatus(false);
    } catch (error) {
      console.error(error);
    }
  };

  async function getTranslation(key) {
    const uppercaseLanguage = await AsyncStorage.getItem("preferredLanguage");
    if (translations[key]) {
      return translations[key][uppercaseLanguage] || key;
    }
    return key;
  }

  const renderLanguageSwitch = () => (
    <View style={HeaderStyle.languageSwitchContainer}>
      {languages.map((lang) => (
        <TouchableOpacity
          key={lang.code}
          style={[
            HeaderStyle.languageSwitchButton,
            language === lang.code && HeaderStyle.languageSwitchButtonActive
          ]}
          onPress={() => handleLanguageChange(lang.code)}
        >
          <CountryFlag isoCode={lang.flag} style={HeaderStyle.languageFlag} />
        </TouchableOpacity>
      ))}
    </View>
  );

  const renderRightComponent = (user) => (
    <View style={{ alignItems: "center", flexDirection: "column" }}>
      <View>
        <Text style={{ color: "white", fontSize: 20, fontWeight: "bold", marginRight: 10 }}>
          {user.firstName}
        </Text>
      </View>
      <View>
        <Text style={{ color: "white", fontSize: 20, fontWeight: "bold", marginRight: 10 }}>
          {user.lastName}
        </Text>
      </View>
    </View>
  );

  return (
    <View style={HeaderStyle.container}>
      <View style={HeaderStyle.firstLine}>
        <Image source={require("../logos/eco8-negativ-A.png")} style={HeaderStyle.logo} />

        {renderLanguageSwitch()}

        <TouchableOpacity onPress={handleLogout}>
          <FontAwesome name="sign-out" size={24} color="white" />
        </TouchableOpacity>
      </View>
      <View style={HeaderStyle.secondLine}>
        <View style={HeaderStyle.secondLineAlignment}>
          <MaterialCommunityIcons name={icon} size={24} color="white" style={HeaderStyle.tabIcon} />
          <View>
            <Text style={HeaderStyle.title}>{translatedTitle}</Text>
            {subtitle && <Text style={HeaderStyle.subtitle}>{translatedSubtitle}</Text>}
          </View>
        </View>
        {user && renderRightComponent(user)}
      </View>
    </View>
  );
};

export default Header;

























